import { useRef } from 'react';
import { Circle, Layer, Stage } from 'react-konva';
import { useGridCorner } from './GridCornerProvider';

function GridCornerLayer(props) {
	const { data, setData } = useGridCorner();
	const { size, originalSize } = props;
	const stageRef = useRef(null);
	const layerRef = useRef(null);
	const scale = size.height / originalSize.height;

	const handleStageClick = e => {
		const clickPos = layerRef.current.getRelativePointerPosition();
		if (data.length === 4) {
			setData([clickPos]);
		} else {
			setData([...data, clickPos]);
		}
	};

	return (
		<Stage
			width={size.width}
			height={size.height}
			ref={stageRef}
			onClick={e => {
				handleStageClick(e);
			}}
		>
			<Layer ref={layerRef} width={originalSize.width} height={originalSize.height} scaleX={scale} scaleY={scale}>
				{data.map(v => (
					<Circle x={v.x} y={v.y} fill="red" radius={scale < 1 ? 5 : 2} />
				))}
			</Layer>
		</Stage>
	);
}

export default GridCornerLayer;
